"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("../constants");
var _createAction = require("../helpers/createAction.js");
var PracticeExam = /*#__PURE__*/_createClass(function PracticeExam(api) {
  var _this = this;
  _classCallCheck(this, PracticeExam);
  this.practiceExamLoading = function (key, promise, dispatch) {
    dispatch({
      type: _constants.PRACTICE_EXAM_TEMPLATE_LOADING,
      payload: {
        key: key,
        promise: promise
      }
    });
  };
  this.practiceExamError = function (error, dispatch, key) {
    dispatch({
      type: _constants.PRACTICE_EXAM_TEMPLATE_LOADING_ERROR,
      payload: {
        error: error,
        key: key
      }
    });
    return error;
  };
  this.createPracticeExamAction = function (actionType, keyMethod) {
    var restAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'post';
    var urlGenerator = arguments.length > 3 ? arguments[3] : undefined;
    var action = function action(userId, questionBankId, practiceExamTemplateId, blockId, questionId) {
      return function (dispatch, getState) {
        var key = keyMethod(practiceExamTemplateId);
        var _getState = getState(),
          loading = _getState.loading;
        if (loading.has(key)) return loading.get(key);
        var url = urlGenerator ? urlGenerator(userId, questionBankId, practiceExamTemplateId, blockId, questionId) : "users/".concat(userId, "/question_banks/").concat(questionBankId, "/practice_exam_templates/").concat(practiceExamTemplateId);
        var promise = _this.api[restAction](url).then(function (response) {
          dispatch({
            type: actionType,
            payload: _objectSpread({
              key: key
            }, response)
          });
          return response;
        }).catch(function (error) {
          return _this.practiceExamError(error, dispatch, key);
        });
        _this.practiceExamLoading(key, promise, dispatch);
        return promise;
      };
    };
    action.getKey = keyMethod;
    return action;
  };
  this.getPracticeExamTemplateKey = function (practiceExamTemplateId) {
    return "practice-exams/".concat(practiceExamTemplateId, "/fetch");
  };
  this.practiceExamTemplateFetch = this.createPracticeExamAction(_constants.PRACTICE_EXAM_TEMPLATE_FETCHED, this.getPracticeExamTemplateKey, 'get');
  this.getDeleteTemplateBlockKey = function (practiceExamTemplateId) {
    return "practice-exams/".concat(practiceExamTemplateId, "/delete-template-block");
  };
  this.getDeleteTemplateURL = function (userId, questionBankId, practiceExamTemplateId, blockId) {
    return "users/".concat(userId, "/question_banks/").concat(questionBankId, "/practice_exam_templates/").concat(practiceExamTemplateId, "/remove_block/").concat(blockId);
  };
  this.deleteTemplateBlock = this.createPracticeExamAction(_constants.PRACTICE_EXAM_TEMPLATE_FETCHED, this.getDeleteTemplateBlockKey, 'patch', this.getDeleteTemplateURL);
  this.getAddQuestionKey = function (practiceExamTemplateId) {
    return "practice-exams/".concat(practiceExamTemplateId, "/add-question");
  };
  this.getAddQuestionURL = function (userId, questionBankId, practiceExamTemplateId, blockId, questionId) {
    return "users/".concat(userId, "/question_banks/").concat(questionBankId, "/practice_exam_templates/").concat(practiceExamTemplateId, "/add_question/").concat(blockId, "/").concat(questionId);
  };
  this.addQuestion = this.createPracticeExamAction(_constants.PRACTICE_EXAM_TEMPLATE_FETCHED, this.getAddQuestionKey, 'patch', this.getAddQuestionURL);
  this.getRemoveQuestionKey = function (practiceExamTemplateId) {
    return "practice-exams/".concat(practiceExamTemplateId, "/remove-question");
  };
  this.getRemoveQuestionURL = function (userId, questionBankId, practiceExamTemplateId, blockId, questionId) {
    return "users/".concat(userId, "/question_banks/").concat(questionBankId, "/practice_exam_templates/").concat(practiceExamTemplateId, "/remove_question/").concat(blockId, "/").concat(questionId);
  };
  this.removeQuestion = this.createPracticeExamAction(_constants.PRACTICE_EXAM_TEMPLATE_FETCHED, this.getRemoveQuestionKey, 'patch', this.getRemoveQuestionURL);
  this.getMoveTemplateBlockKey = function (practiceExamTemplateId) {
    return "practice-exams/".concat(practiceExamTemplateId, "/move-template-block");
  };
  this.moveTemplateBlock = (0, _createAction.createApiRequestAction)({
    getKey: this.getMoveTemplateBlockKey,
    request: function request(getState, userId, questionBankId, practiceExamTemplateId, blockId, newPosition) {
      return _this.api.patch("users/".concat(userId, "/question_banks/").concat(questionBankId, "/practice_exam_templates/").concat(practiceExamTemplateId, "/move_block/").concat(blockId, "/").concat(newPosition));
    },
    loadingConstant: _constants.PRACTICE_EXAM_TEMPLATE_LOADING,
    loadedConstant: _constants.PRACTICE_EXAM_TEMPLATE_FETCHED,
    errorConstant: _constants.PRACTICE_EXAM_TEMPLATE_LOADING_ERROR
  });
  this.getUpdateTemplateBlockKey = function (practiceExamTemplateId) {
    return "practice-exams/".concat(practiceExamTemplateId, "/update-template-block");
  };
  this.updateTemplateBlock = (0, _createAction.createApiRequestAction)({
    getKey: this.getUpdateTemplateBlockKey,
    request: function request(getState, userId, questionBankId, practiceExamTemplateId, blockId, blockParams) {
      return _this.api.patch("users/".concat(userId, "/question_banks/").concat(questionBankId, "/practice_exam_templates/").concat(practiceExamTemplateId, "/template_blocks/").concat(blockId, "/"), {
        template_block: blockParams
      });
    },
    loadingConstant: _constants.PRACTICE_EXAM_TEMPLATE_LOADING,
    loadedConstant: _constants.PRACTICE_EXAM_TEMPLATE_FETCHED,
    errorConstant: _constants.PRACTICE_EXAM_TEMPLATE_LOADING_ERROR
  });
  this.getUpdateTemplateKey = function (practiceExamTemplateId) {
    return "practice-exams/".concat(practiceExamTemplateId, "/update-template");
  };
  this.updateTemplate = (0, _createAction.createApiRequestAction)({
    getKey: this.getUpdateTemplateKey,
    request: function request(getState, userId, questionBankId, practiceExamTemplateId, practiceExamTemplateParams) {
      return _this.api.patch("users/".concat(userId, "/question_banks/").concat(questionBankId, "/practice_exam_templates/").concat(practiceExamTemplateId), {
        practice_exam_template: practiceExamTemplateParams
      });
    },
    loadingConstant: _constants.PRACTICE_EXAM_TEMPLATE_LOADING,
    loadedConstant: _constants.PRACTICE_EXAM_TEMPLATE_FETCHED,
    errorConstant: _constants.PRACTICE_EXAM_TEMPLATE_LOADING_ERROR
  });
  this.getCreateTemplateKey = function () {
    return 'practice-exams/create';
  };
  this.createTemplate = (0, _createAction.createApiRequestAction)({
    getKey: this.getCreateTemplateKey,
    request: function request(getState, userId, questionBankId, practiceExamTemplateParams) {
      return _this.api.post("users/".concat(userId, "/question_banks/").concat(questionBankId, "/practice_exam_templates/"), {
        practice_exam_template: practiceExamTemplateParams
      });
    },
    loadingConstant: _constants.PRACTICE_EXAM_TEMPLATE_LOADING,
    loadedConstant: _constants.PRACTICE_EXAM_TEMPLATE_FETCHED,
    errorConstant: _constants.PRACTICE_EXAM_TEMPLATE_LOADING_ERROR
  });
  this.getFetchPracticeExamTemplatesKey = function (questionId) {
    return "practice-exams/by-question/".concat(questionId);
  };
  this.fetchPracticeExamsForQuestion = (0, _createAction.createApiRequestAction)({
    getKey: this.getFetchPracticeExamTemplatesKey,
    request: function request(getState, userId, questionId) {
      return _this.api.get("users/".concat(userId, "/practice_exam_templates/").concat(questionId));
    },
    loadingConstant: _constants.PRACTICE_EXAM_TEMPLATE_LOADING,
    loadedConstant: _constants.PRACTICE_EXAM_TEMPLATE_FETCHED,
    errorConstant: _constants.PRACTICE_EXAM_TEMPLATE_LOADING_ERROR
  });
  this.getAddTemplateBlockKey = function (practiceExamTemplateId) {
    return "practice-exams/".concat(practiceExamTemplateId, "/add-block");
  };
  this.addTemplateBlock = (0, _createAction.createApiRequestAction)({
    getKey: this.getAddTemplateBlockKey,
    request: function request(getState, userId, questionBankId, practiceExamTemplateId, templateBlockParams) {
      return _this.api.patch("users/".concat(userId, "/question_banks/").concat(questionBankId, "/practice_exam_templates/").concat(practiceExamTemplateId, "/add_block"), {
        template_block: templateBlockParams
      });
    },
    loadingConstant: _constants.PRACTICE_EXAM_TEMPLATE_LOADING,
    loadedConstant: _constants.PRACTICE_EXAM_TEMPLATE_FETCHED,
    errorConstant: _constants.PRACTICE_EXAM_TEMPLATE_LOADING_ERROR
  });
  this.api = api;
});
var _default = exports.default = PracticeExam;